---
title: "Terms of Service"
effectiveDate: "2026-02-06"
lastUpdated: "2026-02-06"
---

These Terms of Service ("Terms") govern your use of key.store and related services operated by `key dot store, LLC` (the "Service").
By accessing or using the Service, you agree to these Terms.

## The Service

key.store is building a fast, cross-platform password manager and related authentication tooling.
Parts of the Service may be experimental or may change over time.

## Eligibility

You must be legally able to form a binding contract in your jurisdiction to use the Service.
If you are using the Service on behalf of an organization, you represent that you have authority to accept these Terms on that organization's behalf.

## Accounts and Security

You are responsible for maintaining the confidentiality of your devices, credentials, and recovery information.
You agree to provide accurate information when you choose to provide it (for example, a contact email in a feedback form).

## Acceptable Use

You agree not to:

- Use the Service for unlawful, harmful, or abusive activity.
- Attempt to gain unauthorized access to accounts, systems, or networks.
- Interfere with or disrupt the Service (including by sending excessive traffic, probing, or exploiting vulnerabilities).
- Reverse engineer or bypass safeguards in the Service except to the extent such restrictions are prohibited by law.
- Use the Service to transmit malware or to phish, spam, or harass.

We may suspend or terminate access to the Service if we reasonably believe you have violated these Terms or if needed to protect the Service and users.

## Your Content and Feedback

If you submit feedback, suggestions, or other materials to us, you grant us permission to use them to operate and improve the Service without restriction.
Do not submit sensitive personal information through public channels (for example: issue trackers) unless you intend for it to be public.

## Disclaimers

THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE". TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.

We do not guarantee that the Service will be uninterrupted, error-free, or secure.

## Limitation of Liability

TO THE MAXIMUM EXTENT PERMITTED BY LAW, `key dot store, LLC` WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS, REVENUE, DATA, OR GOODWILL, ARISING OUT OF OR RELATED TO YOUR USE OF THE SERVICE.

## Changes to the Service or Terms

We may modify the Service and these Terms over time.
If we make material changes, we will update the "last updated" date and publish the updated Terms on this page.

## DMCA and Takedown Requests

If you believe content available via the Service infringes your copyright, send a takedown notice to `dmca@key.store`.

Include, at minimum:

- Your contact information.
- Identification of the copyrighted work you claim has been infringed.
- Identification of the allegedly infringing material and sufficient information for us to locate it.
- A statement that you have a good-faith belief the use is not authorized by the copyright owner, its agent, or the law.
- A statement, under penalty of perjury, that the information is accurate and you are authorized to act.
- Your physical or electronic signature.

If you believe your content was removed in error, you may send a counter-notice to `dmca@key.store` with the information required by applicable law.

## Termination

You may stop using the Service at any time.
We may suspend or terminate access to the Service at any time if needed to protect the Service and users, or if you violate these Terms.

## Governing Law

These Terms are governed by the laws applicable to `key dot store, LLC`, without regard to conflict of law principles.
If a court finds a provision of these Terms unenforceable, the remaining provisions will remain in effect.

## Contact

For privacy questions, contact `privacy@key.store`. For DMCA notices, contact `dmca@key.store`.
